import React, { useMemo } from 'react'

import { Grid } from "@material-ui/core";

const project = require('EurestoConfig/project.config')

export default React.memo(props => {

    const token = useMemo(() => localStorage.getItem('token'), [])

    return <iframe style={{ width: '100%', height: '100%' }}
        frameBorder={"0"}
        src={`${project.api.replace(5000, 3000).replace('api', 'cloud')}configuration/etablissement?navigation=off&token=${token}#Marque%20Catégorie`} sandbox />
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Facturation/MarqueCategorie/index.js